import HomeIcon from "@mui/icons-material/Home";
import InfoIcon from "@mui/icons-material/Info";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import PersonIcon from "@mui/icons-material/Person";

export const MenuItems = [
  {
    title: "Home",
    url: "/",
    cName: "nav-links",
    icon: <HomeIcon />,
  },
  {
    title: "About",
    url: "/about",
    cName: "nav-links",
    icon: <InfoIcon />,
  },
  {
    title: "Service",
    url: "/Service",
    cName: "nav-links",
    icon: <BusinessCenterIcon />,
  },
  {
    title: "Contact",
    url: "/Contact",
    cName: "nav-links",
    icon: <PersonIcon />,
  },
  {
    title: "Sign Up",
    url: "/signup",
    // cName: "nav-links-mobile",
    cName: "nav-links-sign",
  },
];
